import { LangObject } from "@brg/api";

export const getTextByLang = (current: LangObject[] | undefined, lang: string): string => {
    if (!Array.isArray(current)) return '';
    const target = (lang || '').toLowerCase() === 'en' ? 'en' : 'ru';
    const found = current.find(({ lang: l }) => (l || '').toLowerCase() === target);
    return found?.name ?? '';
};

const setTextByLang = (
    current: LangObject[],
    lang: string,
    value: string
): LangObject[] => {
    const normalizeLang = (value?: string) => (value || '').toLowerCase();
    const targetLang = normalizeLang(lang) === 'en' ? 'en' : 'ru';

    const engValue = current.find(({ lang }) => normalizeLang(lang) === 'en');
    const ruValue = current.find(({ lang }) => normalizeLang(lang) === 'ru');

    if (targetLang === 'ru') {
        return [
            { lang: 'ru', name: value },
            ...(engValue
                ? [{ ...engValue }]
                : [{ lang: 'en', name: value }]),
        ];
    }

    return [
        ...(ruValue
            ? [{ ...ruValue }]
            : [{ lang: 'ru', name: value }]),
        { lang: 'en', name: value },
    ];
};

export default setTextByLang;import { LangObject } from "@brg/api";

export const getTextByLang = (current: LangObject[] | undefined, lang: string): string => {
    if (!Array.isArray(current)) return '';
    const target = (lang || '').toLowerCase() === 'en' ? 'en' : 'ru';
    const found = current.find(({ lang: l }) => (l || '').toLowerCase() === target);
    return found?.name ?? '';
};

const setTextByLang = (
    current: LangObject[],
    lang: string,
    value: string
): LangObject[] => {
    const normalizeLang = (value?: string) => (value || '').toLowerCase();
    const targetLang = normalizeLang(lang) === 'en' ? 'en' : 'ru';

    const engValue = current.find(({ lang }) => normalizeLang(lang) === 'en');
    const ruValue = current.find(({ lang }) => normalizeLang(lang) === 'ru');

    if (targetLang === 'ru') {
        return [
            { lang: 'ru', name: value },
            ...(engValue
                ? [{ ...engValue }]
                : [{ lang: 'en', name: value }]),
        ];
    }

    return [
        ...(ruValue
            ? [{ ...ruValue }]
            : [{ lang: 'ru', name: value }]),
        { lang: 'en', name: value },
    ];
};

export default setTextByLang;